module.exports = __webpack_public_path__ + "static/numbers-2-3-7108c6f33c3c658d07cc57c7c28630a7.png";